import React from 'react';
import { Modal, Input, Form, Select, Checkbox, Button, DatePicker, Icon } from 'antd';
import moment from 'moment';

import { FORMAT_2DECIMALS } from '../../../common/types/regularExpresionType';
import global from '../../../common/utility/global';

const { Option } = Select;
const InputGroup = Input.Group;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleAutocompleteCuentaContable = async (value) => {
        if (value.length > 2) {
            const result = this.props.formValues.cuentasContables.filter(item => {
                return (item.cuentaContable + ' - ' + item.nombre)
                    .toUpperCase()
                    .match(value.toUpperCase());
            });
            this.props.form.setFieldsValue({ cuentasContableFiltered: result });
        }
        else
            this.props.form.setFieldsValue({ cuentasContableFiltered: [] });
    };

    saldoInicialDebeComplete2Decimals = (e) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(2)))
            this.props.form.setFieldsValue({ saldoInicialDebe: '0.00' });
        else
            this.props.form.setFieldsValue({ saldoInicialDebe: parseFloat(e.target.value).toFixed(2) });
    }

    saldoInicialHaberComplete2Decimals = (e) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(2)))
            this.props.form.setFieldsValue({ saldoInicialHaber: '0.00' });
        else
            this.props.form.setFieldsValue({ saldoInicialHaber: parseFloat(e.target.value).toFixed(2) });
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoCuenta: values.idTipoCuenta.key,
                    cuentaBancario: values.cuentaBancario,
                    cuentaInterbancario: values.cuentaInterbancario,
                    idEntidad: values.idEntidad.key,
                    idMoneda: values.idMoneda.key,
                    idPlanCuenta: values.idPlanCuenta ? values.idPlanCuenta.key : 0,
                    flagView: values.flagView,
                    flagContabilidad: values.flagContabilidad,
                    fechaStr: values.fechaStr.format('DD/MM/YYYY'),
                    saldoInicialDebe: parseFloat(values.saldoInicialDebe),
                    saldoInicialHaber: parseFloat(values.saldoInicialHaber),
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('cuentasContableFiltered', {
            initialValue: this.props.formValues.cuentasContables
                .filter(m => { return m.id === this.props.formValues.idPlanCuenta })
        });
        return (
            <Modal
                title={(this.props.formValues.id === 0 ? "Registrar" : "Modificar") + " Cuenta"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="700px"
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Tipo de Cuenta">
                                {getFieldDecorator('idTipoCuenta', {
                                    initialValue: this.props.formValues.idTipoCuenta > 0 ?
                                        { key: this.props.formValues.idTipoCuenta } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Cuenta"}
                                        optionFilterProp="children"
                                        onChange={(option, item) => {
                                            this.props.onChangeTipoCuenta(item.props.data === '1' ? true : false);
                                            this.props.form.setFieldsValue({ idEntidad: undefined });
                                        }}
                                    >
                                        {this.props.formValues.tiposCuenta.map(item => (
                                            <Option key={item.id} value={item.id} data={item.flagBanco ? '1' : '0'}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda > 0 ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cuenta Bancaria">
                                {getFieldDecorator('cuentaBancario', {
                                    initialValue: this.props.formValues.cuentaBancario,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        onKeyPress={global.onKeyPressNumber}
                                        placeholder="Ingresar Cuenta Bancaria"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cuenta Interbancaria">
                                {getFieldDecorator('cuentaInterbancario', {
                                    initialValue: this.props.formValues.cuentaInterbancario,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        onKeyPress={global.onKeyPressNumber}
                                        placeholder="Ingresar Cuenta Interbancaria"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Banco">
                                {getFieldDecorator('idEntidad', {
                                    initialValue: this.props.formValues.idEntidad > 0 ?
                                        { key: this.props.formValues.idEntidad } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Banco"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.entidades.map(item => (
                                            <Option key={item.id} value={item.id} >{item.name}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cuenta Contable">
                                <InputGroup compact>
                                    {getFieldDecorator('idPlanCuenta', {
                                        initialValue: this.props.formValues.idPlanCuenta ?
                                            { key: this.props.formValues.idPlanCuenta } : undefined
                                    })(
                                        <Select showSearch labelInValue
                                            style={{ width: `calc(100% - 40px)` }}
                                            placeholder={"Búsqueda de Cuenta Contable Compra"}
                                            optionFilterProp="children"
                                            showArrow={false}
                                            onSearch={this.handleAutocompleteCuentaContable}
                                            onChange={(value) => this.props.form.setFieldsValue({ idPlanCuenta: value })}
                                        >
                                            {getFieldValue('cuentasContableFiltered').map(item => (
                                                <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                    <Button
                                        className="btn-autocomplete"
                                        icon="close-circle"
                                        style={{ width: '40px' }}
                                        onClick={() => this.props.form.setFieldsValue({ idPlanCuenta: undefined })}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Fecha Apertura">
                                {getFieldDecorator('fechaStr', {
                                    initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Requerido'
                                    }],
                                })(
                                    <DatePicker
                                        placeholder="Seleccione fecha"
                                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        format="DD/MM/YYYY"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Contabilidad">
                                {getFieldDecorator('flagContabilidad', {
                                    initialValue: this.props.formValues.flagContabilidad,
                                    valuePropName: 'checked'
                                })(<Checkbox></Checkbox>)}
                            </Form.Item>
                        </div>

                        <div className="col-md-3 form-group">
                            <Form.Item label="Visualizar en PDF">
                                {getFieldDecorator('flagView', {
                                    initialValue: this.props.formValues.flagView,
                                    valuePropName: 'checked'
                                })(<Checkbox></Checkbox>)}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Saldo Inicial Debe">
                                {getFieldDecorator('saldoInicialDebe', {
                                    initialValue: parseFloat(this.props.formValues.saldoInicialDebe).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato decimal incorrecto (0.00)"
                                    }]
                                })(
                                    <Input
                                        className="text-right"
                                        placeholder="Ingresar Saldo Inicial"
                                        autoComplete="off"
                                        onBlur={this.saldoInicialDebeComplete2Decimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Saldo Inicial Haber">
                                {getFieldDecorator('saldoInicialHaber', {
                                    initialValue: parseFloat(this.props.formValues.saldoInicialHaber).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato decimal incorrecto (0.00)"
                                    }]
                                })(
                                    <Input
                                        className="text-right"
                                        placeholder="Ingresar peso"
                                        autoComplete="off"
                                        onBlur={this.saldoInicialHaberComplete2Decimals}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)